export default class ProductsListCtrl {
  constructor ($scope, $stateParams, $timeout, WorkPlanSrv, WorkPlanModalSrv, GlobalConfig, $cookies, $state, $mdDialog, $filter, Requests, $sessionStorage) {
  // constants
  const productsVm = this
  const currentUser = $cookies.getObject('currentUser')

  let post = {
    teacherId: currentUser.teacherId,
    workplanId: currentUser.workplanId
  }

  // variables
  productsVm.productsList = []
  productsVm.viewLoaded = true
  productsVm.criteriaFilter = ''
  productsVm.selectedProduct = null
  productsVm.productParent = null
  productsVm.isLoadingDetails = false
  productsVm.imgEmpty = require('../../../../../../assets/images/empty_state_illustration.svg')
  productsVm.active = GlobalConfig.generals.active
  productsVm.notActive = GlobalConfig.generals.notActive
  productsVm.planningFinish = true
  $scope.classPlanning = ''
  productsVm.sr = ''
  productsVm.searchValue = false
  productsVm.feedback = 0
  productsVm.workPlanGeneralList = $sessionStorage.workPlanGeneralList
  productsVm.$sessionStorage = $sessionStorage

  // methods
  productsVm.productBckgrd = productBckgrd
  productsVm.productText = productText
  productsVm.details = details
  productsVm.close = close
  productsVm.updateFilter = updateFilter
  productsVm.addActivityProduct = addActivityProduct
  productsVm.getGeneralsWorkplan = getGeneralsWorkplan
  productsVm.searchResult = searchResult
  productsVm.bitacora = bitacora
  productsVm.disableProductActivyId = disableProductActivyId
  productsVm.eliminarProducto = eliminarProducto


    // data validations
    productsVm.thereIsDetails = thereIsDetails

  // services

  activate()

  function activate () {
    if(productsVm.workPlanGeneralList != undefined){
      productsVm.status = productsVm.workPlanGeneralList.wokplanTeacherStatus[0]
      productsVm.stages = productsVm.workPlanGeneralList.stages
      productsVm.feedback = productsVm.status.feedbackReviewed
      productsVm.workplanTeacherId = productsVm.status.workplanTeacherId
      isPlanning(productsVm.status, productsVm.stages)
      
      if(productsVm.feedback && !productsVm.planningFinish){
        getDataFormProductReject()
      }else{ 
        getDataFormProduct() 
      }
    }else{
      getGeneralsWorkplan(post).then((promise) => {
        if(productsVm.feedback && !productsVm.planningFinish){
          getDataFormProductReject()
        }else{ 
          getDataFormProduct() 
        }
      })
    }
  }

  function getDataFormProduct () {
    return WorkPlanSrv.getDataFormProduct.getList(post).$promise.then(
      dataReturn => {
        if (dataReturn.status) {
          productsVm.productsList = dataReturn.listProducts
          if (productsVm.productsList.length == 0) {
            productsVm.productParent = 0
          }

          if (productsVm.productsList && productsVm.productsList.length > 0) {
            productsVm.details(productsVm.productsList[0])
          }
        } else {
          console.log('Comunications problem')
        }
      },
      data => {
        console.log()
      }
      )
  }

  function getDataFormProductReject () {
    return WorkPlanSrv.getDataFormProductReject.getList(post).$promise.then(
      dataReturn => {
        if (dataReturn.status) {
          productsVm.productsList = dataReturn.listProducts
          if (productsVm.productsList.length == 0) {
            productsVm.productParent = 0
          }

          if (productsVm.productsList && productsVm.productsList.length > 0) {
            productsVm.details(productsVm.productsList[0])
          }
        } else {
          console.log('Comunications problem')
        }
      },
      data => {
        console.log()
      }
      )
  }

  function validateSearch () {
    return $filter('filter')(productsVm.productsList, productsVm.criteriaFilter)
  }

  function searchResult () {
    productsVm.sr = validateSearch()
  }

  function getProductDetails (product, reload = false) {
    WorkPlanSrv.getProductByActivityId.get({workplanTeacherActivityId: product.workplanTeacherActivityId}).$promise.then(
      dataReturn => {
        if (dataReturn.status) {
          productsVm.productParent = dataReturn.data.parent
          productsVm.productChilds = dataReturn.data.childs
        } else {
          console.log('Comunications problem')
        }
      },
      data => {
        console.log()
      }
      )

    if (!reload) {
      productsVm.isLoadingDetails = true
      productsVm.productParent = null
    }
  }

  function thereIsDetails () {
    return productsVm.productParent !== null
  }

  function productBckgrd (product) {
    if (productsVm.selectedProduct === product) {
      return 'bg-review'
    }
  }

  function productText (product) {
    if (productsVm.selectedProduct === product) {
      return 'text-color-w'
    }
  }

  function details (product) {
    productsVm.selectedproduct = product
    getProductDetails(product)
  }

  function close () {
    return $mdDialog.hide()
  }

  function updateFilter (val) {
    productsVm.criteriaFilter = val
    productsVm.sr = validateSearch()
    if (productsVm.sr.length == 0) {
      productsVm.searchValue = true
      productsVm.productParent = null
    } else {
      productsVm.searchValue = false
      if (productsVm.productsList && productsVm.productsList.length > 0) {
        productsVm.details(productsVm.productsList[0])
      }
    }
  }

  function addActivityProduct (product, activity) {
    let header = {
      workplanTeacherActivityIdParent: product.workplanTeacherActivityId,
      children: activity || 'ADD',
      hoursChildren : product.hoursChildren
    }

    WorkPlanModalSrv.setVariable(header)
    WorkPlanModalSrv.addActivityProduct().then((promise) => {
      let shared = WorkPlanModalSrv.getVariable()
      if (shared) {
          // getProductDetails(product)
          if (shared.action === 'ADD') {
            productsVm.productChilds.push(shared.child)
          } else if (shared.action === 'EDIT') { 
            for (var i = productsVm.productChilds.length - 1; i >= 0; i--) {
              if (productsVm.productChilds[i].workplanTeacherActivityId === shared.child.workplanTeacherActivityId) {
                productsVm.productChilds[i].name = shared.child.name
                productsVm.productChilds[i].hoursPlanned = shared.child.hoursPlanned
                productsVm.productChilds[i].description = shared.child.description
                productsVm.productChilds[i].endDate = shared.child.endDate
                productsVm.productChilds[i].startDate = shared.child.startDate
                productsVm.productChilds[i].timeRangeTypeId = parseInt(shared.child.timeRangeTypeId)
                productsVm.productChilds[i].periods = shared.child.periods
                //productsVm.productChilds[i].periodId = shared.child.periods
              }
            }
          }
        }
      })
  }

  function endPlanning () {
    let post = {
      teacherId: currentUser.teacherId,
      workplanId: currentUser.workplanId,
      userId: currentUser.id,
      stageId: GlobalConfig.workplanIdStages.planning,
      stageName: GlobalConfig.workplanStagesNames.planning,
      submodules: $cookies.getObject('subModuleId'),
      teaching: GlobalConfig.modules.teaching,
      academicManagement: GlobalConfig.modules.academicManagement,
      feedback: productsVm.feedback
    }

    let submodules = Requests.submoduleItemRequired(post)

    if (submodules.teaching || submodules.academicManagement) {
      Requests.getItemsRequiredList(WorkPlanSrv, post).then((data) => {
        data.submodule = submodules

        if (Requests.validateItems(data)) {
          Requests.showModalItemRequiredEndPlanning(WorkPlanModalSrv, data)
        } else { Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post) }
        activate()
      })
    } else {
      Requests.showModalEndPlannig(WorkPlanSrv, WorkPlanModalSrv, post)
      activate()
    }
  }

  function getGeneralsWorkplan (post) {
    return WorkPlanSrv.getElementsRightBar.getList({teacherId: post.teacherId}).$promise.then(function (dataReturn) {
      if (dataReturn.status) {
        productsVm.$sessionStorage.workPlanGeneralList = dataReturn.data
        productsVm.status = dataReturn.data.wokplanTeacherStatus[0]
        productsVm.stages = dataReturn.data.stages
        productsVm.feedback = productsVm.status.feedbackReviewed
        productsVm.workplanTeacherId = productsVm.status.workplanTeacherId
        isPlanning(productsVm.status, productsVm.stages)
      } else {
        console.log('Comunications problem with the server')
      }
    }, function (data) {
      console.log(data)
    })
  }

  function disableProductActivyId (wplt,product,ev) {

    eliminarProducto(ev).then((answer) => {
      if (answer) {
        return  WorkPlanSrv.disableProductActivyId.get({workplanTeacherId: wplt}).$promise.then((response) => {
          if (!response.status) {
            this.ngNotify.set('Ocurrio un error en el servicio', 'warn');
          } else {
            getDataFormProduct();
            getProductDetails (product,false);
          }
        }, (err) => {
          this.ngNotify.set('Imposible conectar con el servicio', 'error');
        });
      }
    })

  }

  function isPlanning (status, stages) {
    productsVm.currentDate = moment(new Date()).format('DD/MM/YYYY')
    for (var i = stages.length - 1; i >= 0; i--) {
      if (stages[i].stageId == GlobalConfig.workplanIdStages.review) {
        productsVm.startDateStage = stages[i].startDate
      }
    }
    if(status.workplanActive){
      if (status.planningFinish == productsVm.active) {
        productsVm.planningFinish = true
        if (productsVm.startDateReview < productsVm.currentDate || status.reviewedFinish == productsVm.active) {
          productsVm.planningFinish = true
        } else if (status.reviewedReject == productsVm.active) {
          productsVm.planningFinish = false
        }
      } else {
        productsVm.planningFinish = false
      }
    }else{
      productsVm.planningFinish = true
    }

    $scope.classPlanning = (productsVm.planningFinish ? 'disabled' : ' ')
  }

  function bitacora (ev) {
    let entries = {}

    entries.params = {
      activityTypeId: GlobalConfig.activityTypeId.products,
      workplanTeacherId: productsVm.workplanTeacherId
    }
    entries.title = 'Productos'
      // Entries(this.entries);
      entries.data = undefined
      $mdDialog.show({
        controller: 'bitacoraModalCtrl',
        controllerAs: 'bit',
        template: require('../../../../strategicTracking/detailsByTeacher/bitacoraModal/bitacoraModal.html'),
        parent: angular.element(document.body),
        targetEvent: ev,
        locals: {data: entries},
        clickOutsideToClose: true,
        fullscreen: true
      })
    }


    function eliminarProducto (ev) {
      return $mdDialog.show({
        controller: ['$scope', '$mdDialog',productDeleteCtrl],
        controllerAs: 'productDelete',
        template: require('./modal/productDelete.html'),
        parent: angular.element(document.body),
        targetEvent: ev
      })
    };

    function productDeleteCtrl($scope, $mdDialog) {
      $scope.close = function(answer) {
        $mdDialog.hide(answer);
      };
    }

  }
}

ProductsListCtrl.$inject = ['$scope', '$stateParams', '$timeout', 'WorkPlanSrv', 'WorkPlanModalSrv', 'GlobalConfig', '$cookies', '$state', '$mdDialog', '$filter', 'Requests', '$sessionStorage']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/products/list/productsListCtrl.js